const ChatChevronIcon = ({ direction = "start", className = "w-5 h-5" }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d={direction === "end" ? "M9 5l7 7-7 7" : "M15 19l-7-7 7-7"}
    />
  </svg>
);

export default ChatChevronIcon;
